export default  {
    component: 'soilsensor',
    name: 'soilsensor',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Block ID',
            param: 'block_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> Should always start from ID **"1"**`
          },
          {
            name: 'Soil Sensor ID',
            param: 'soil_sensor_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> For each block, soil sensor id should start from **"1"**`
          },
          {
            name: 'Device ID',
            param: 'device_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> For each block, soilsensor id should start from **"1"**`
          },
          {
            name: 'Soilsensor Name',
            param: 'soilsensor_name',
            type: 'text',
            description: `> For each soilsensor device name should be unique`
          },
          {
            name: 'Param Config',
            param: 'param_config',
            type: 'json',
          },
          {
            name: 'Parameter List',
            param: 'param_list',
            type: 'text',
            description: `> In order to remove unwanted parameters from analytics. *\(e.g rm-soiling_ratio1,rm-transmit_loss1,rm-soiling_ratio2,rm-transmit_loss2)`
          },
          {
            name: 'Name Config',
            param: 'name_config',
            type: 'text',
            description: `The name should be unique. Name Concatination of blockname-devicename`
          },
    ]
  }


